export const IconPackage = ({ size, color }) => (
  <div style={{ display: 'flex' }}>
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9314 9.50098V4.64257C11.9312 4.42957 11.875 4.22038 11.7684 4.03597C11.6618 3.85156 11.5086 3.69843 11.3241 3.59193L7.07302 1.16273C6.88838 1.05612 6.67893 1 6.46572 1C6.25251 1 6.04306 1.05612 5.85842 1.16273L1.6073 3.59193C1.42284 3.69843 1.26963 3.85156 1.16304 4.03597C1.05644 4.22038 1.00022 4.42957 1 4.64257V9.50098C1.00022 9.71398 1.05644 9.92317 1.16304 10.1076C1.26963 10.292 1.42284 10.4451 1.6073 10.5516L5.85842 12.9808C6.04306 13.0874 6.25251 13.1435 6.46572 13.1435C6.67893 13.1435 6.88838 13.0874 7.07302 12.9808L11.3241 10.5516C11.5086 10.4451 11.6618 10.292 11.7684 10.1076C11.875 9.92317 11.9312 9.71398 11.9314 9.50098Z"
        stroke={color !== '' ? color : `white`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16406 4.01086L6.46581 7.07774L11.7676 4.01086"
        stroke={color !== '' ? color : `white`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46582 13.1934V7.07178"
        stroke={color !== '' ? color : `white`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)
